import React, {useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthProvider';
 
const P404 = () => {
 


  return (
    < > 


         <div class="container-fluid">
               <div class="row" style={{minHeight:500,}}>
                  <h1>404!!</h1>

                  

                   
 
               </div>


            
         </div>
        
        
  
        
 
        
  
      
    </>
  );
};

export default P404;

